import {FormError} from "@/components/ui/forms/FormError";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {DropCalendar} from "@ui/general/DropCalendar";
import {DropRangeCalendar} from "@ui/general/DropRangeCalendar";
import {EditInput} from "@ui/inputs/EditInput";
import EditSelect from "@ui/inputs/EditSelect";
import {RootCheckbox} from "@ui/inputs/RootCheckbox";
import {RootTextarea} from "@ui/inputs/RootTextarea";

export const EditField = ({
  label,
  value,
  onChange,
  placeholder,
  type = "input",
  width,
  fontSize = 18,
  options = [],
  onSelect,
  height = "auto",
  searchPlaceholder,
  validation,
  activeOption,
  emptyResult,
  multiSelect = false,
  date,
  setDate,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  checked,
  customContent,
  error,
  direction = "row",
  selectKey,
  resetKey,
}) => (
  <li className={`relative flex items-start gap-[24rem] flex-${direction}`}>
    {error && (
      <FormError
        error={error}
        bottom={-20}
      />
    )}

    <RootDesc>
      <b
        className={`block w-[250rem] phone:w-[100%]`}
        dangerouslySetInnerHTML={{__html: label}}
      />
    </RootDesc>

    {type === "textarea" ? (
      <RootTextarea
        type={"text"}
        value={value}
        onChange={onChange}
      />
    ) : type === "select" ? (
      <EditSelect
        key={selectKey}
        resetKey={resetKey}
        width={width}
        height={height}
        searchPlaceholder={searchPlaceholder}
        activeOption={activeOption}
        options={options}
        onSelect={onSelect}
        emptyResult={emptyResult}
        multiSelect={multiSelect}
      />
    ) : type === "date" ? (
      <DropCalendar
        date={date}
        setDate={setDate}
      />
    ) : type === "range_date" ? (
      <div className={"p-[4rem_8rem]"}>
        <DropRangeCalendar
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
        />
      </div>
    ) : type === "checkbox" ? (
      <RootCheckbox
        checked={checked}
        onChange={onChange}
      />
    ) : type === "custom" ? (
      customContent
    ) : (
      <EditInput
        width={width}
        placeholder={placeholder}
        type={"text"}
        value={value}
        onChange={onChange}
        fontSize={fontSize}
        validation={validation}
      />
    )}
  </li>
);
